<template>
  <b-container fluid>
    <SlicesBlock :slices="slices" />
  </b-container>
</template>

<script>
// import { uids } from '../landings.json';
import { uids as uidsExcluded } from '../excluded-landings.json';
import SlicesBlock from '@/components/Prismic/Landings/SlicesBlock.vue';

export default {
  name: 'Post',
  components: {
    SlicesBlock
  },
  layout: 'landings',
  async asyncData({ $prismic, params, error, store }) {
    try {
      let languages = $prismic.api.data.languages;
      let language = languages.find((item) => item.id.indexOf(store.$i18n.locale) != -1);

      // START - Uncomment this before lunch
      // Parse language id for cases like: 'en-us'
      // const exists = uids.some((el) => el[languageCode] === params.uid);

      // if (!exists) {
      //   error({ statusCode: 404, message: 'Page not found' });
      //   return;
      // }
      // END

      const languageCode = language.id.split('-')[0];
      const isExcluded = uidsExcluded.some((el) => el[languageCode] === params.uid);

      if (isExcluded) {
        error({ statusCode: 404, message: 'Page not found' });
        return;
      }

      const result = await $prismic.api.getByUID('post', params.uid, { lang: language.id });

      if (!result) {
        return error({ statusCode: 404, message: 'Page not found' });
      }

      const locales = store.$i18n.locales;

      let alternateLanguages = result.alternate_languages;
      let actualDomain = locales.find((item) => language.id.startsWith(item.iso) == true);

      let hrefLangActual = {
        rel: 'alternate',
        href: `https://${actualDomain.domain}/${result.uid}`,
        hreflang: actualDomain.iso
      };

      let hrefLangs = alternateLanguages.map((item) => {
        let aux = locales.find((itemAux) => item.lang.startsWith(itemAux.iso) == true);
        return {
          rel: 'alternate',
          href: `https://${aux.domain}/${item.uid}`,
          hreflang: aux.iso
        };
      });

      hrefLangs.push(hrefLangActual);

      const post = result.data;

      const hasMetaTitle = post['meta-title'][0]?.text;
      const metaTitle = hasMetaTitle ? hasMetaTitle : '';

      const hasMetaDescription = post['meta-description'][0]?.text;
      const metaDescription = hasMetaDescription ? hasMetaDescription : '';

      const hasOpenGraphTitle = post['open_graph_title'][0]?.text;
      const openGraphTitle = hasOpenGraphTitle ? hasOpenGraphTitle : metaTitle;

      const hasOpenGraphDescription = post['open_graph_description'][0]?.text;
      const openGraphDescription = hasOpenGraphDescription
        ? hasOpenGraphDescription
        : metaDescription;

      const hasOpenGraphImage = post['open_graph_image']['url'];
      const openGraphImage = hasOpenGraphImage ? hasOpenGraphImage : '';

      const openGraph = {
        openGraphTitle,
        openGraphDescription,
        openGraphImage
      };

      const hasCanonicalName = post['canonical_name'][0]?.text;
      const canonicalName = hasCanonicalName ? hasCanonicalName : result.uid;

      const canonical = {
        rel: 'canonical',
        href: `https://${actualDomain.domain}/${canonicalName}/`
      };

      const experience = post.experience;
      const merch = store.getters['experience/getMerch'];
      const design = store.getters['experience/getDesign'];

      if (experience === merch || experience === design) {
        store.commit('experience/SET_USER_EXPERIENCE', experience);
      }

      return {
        document: post,
        slices: post.body,
        seoFields: {
          metaTitle,
          metaDescription,
          hrefLangs,
          ...openGraph,
          canonical
        },
        formattedDate: Intl.DateTimeFormat(language, {
          year: 'numeric',
          month: 'short',
          day: '2-digit'
        }).format(new Date(post.date))
      };
    } catch (e) {
      console.error('Page UID', e);
      error({ statusCode: 404, message: 'Page not found' });
    }
  },
  head() {
    const i18nSeo = this.$seoPlugin({ hreflang: false, canonical: false });
    return {
      title: this.seoFields.metaTitle,
      htmlAttrs: i18nSeo.htmlAttrs,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.seoFields.metaDescription
        },
        {
          property: 'og:type',
          content: 'website',
          vmid: 'og:type'
        },
        {
          property: 'og:title',
          content: this.seoFields.openGraphTitle,
          vmid: 'og:title'
        },
        {
          property: 'og:description',
          content: this.seoFields.openGraphDescription,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.seoFields.openGraphImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:card',
          content: 'summary_large_image',
          vmid: 'twitter:card'
        },
        {
          property: 'twitter:title',
          content: this.seoFields.openGraphTitle,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:description',
          content: this.seoFields.openGraphDescription,
          vmid: 'twitter:description'
        },
        {
          property: 'twitter:image',
          content: this.seoFields.openGraphImage,
          vmid: 'twitter:image'
        },
        ...i18nSeo.meta
      ],
      link: [...this.seoFields.hrefLangs, ...i18nSeo.link, this.seoFields.canonical]
    };
  }
};
</script>
